import {
  Component,
  inject,
  ElementRef,
  ViewChild,
  OnInit,
  computed,
  NgZone,
  effect,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { toSignal } from '@angular/core/rxjs-interop';
import { DevicesService } from '../bots/devices.service';
import { BroadCastService } from './broadcast.service';
import { DeviceWebSocketService } from '../bots/device.websocket.service';
import { VideoPlayerComponent } from '../videoPlayer/video-component';
import { Router } from '@angular/router';
import { CockpitDesignerStore } from '../cockpitDesigner/cockpitDesigner.service';
import { CockpitComponentRenderer } from '../cockpitComponents/ComponentRender/component-renderer.component';
import { CockpitService } from './cockpit.service';

declare global {
  interface Window {
    createSession: any; // make TS aware of the JS function
  }
}

@Component({
  selector: 'app-cockpit',
  templateUrl: 'cockpit.component.html',
  styleUrls: ['cockpit.component.css'],
  standalone: true,
  imports: [VideoPlayerComponent, CockpitComponentRenderer, CommonModule],
})
export class Cockpit implements OnInit {

  cockpitService = inject(CockpitService);

  constructor() {
    const id = this.route.snapshot.queryParamMap.get('id');
    if (id) {
      this.cockpitService.cockpitDeviceId.set(id);
      this.cockpitService.loadDeviceById(id)
      this.cockpitService.loadDeviceLayout(id)
    }
  }
  @ViewChild('localVideo') localVideo!: ElementRef<HTMLVideoElement>;
  @ViewChild('remoteVideo') remoteVideo!: ElementRef<HTMLVideoElement>;

  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private devicesService = inject(DevicesService);
  private deviceSocketService = inject(DeviceWebSocketService);
  private queryParams = toSignal(this.route.queryParamMap);
  remoteStream = this.devicesService.remoteDeviceStream;
  private broadcast = inject(BroadCastService);
  private ngZone = inject(NgZone);
  store = inject(CockpitDesignerStore);


  private deviceWs = inject(DeviceWebSocketService);
  devices = this.devicesService.devices;
  onlineDevices = this.devicesService.onlineDevices;
  selectedDevice = computed(() => {
    const id = this.queryParams()?.get('id');
    return this.devicesService.onlineDevices().find((d) => d.id === id) ?? null;
  });
  layout = this.cockpitService.cockpitLayout();

  leftOpen = false;
  rightOpen = true;
  chatOpen = true;

  toggleLeft() {
    this.leftOpen = !this.leftOpen;
  }

  toggleRight() {
    this.rightOpen = !this.rightOpen;
  }

  toggleChat() {
    this.chatOpen = !this.chatOpen;
  }

  ngOnInit(): void {
    effect(() => {
      if (!this.remoteStream) return;
      const stream = this.remoteStream();
      if (stream) {
        console.log('Remote stream added!', stream);

        if (this.remoteVideo?.nativeElement) {
          this.remoteVideo.nativeElement.srcObject = stream;
        }
      }
    });
  }

  startPublish() {
    this.broadcast.startPublish(this.localVideo.nativeElement).catch(console.error);
  }
  onPlayerClick() {
    console.log('clicked');
  }
  handleRowClick(rowId:string){
    console.log('clicking the row', rowId)
  }

  openCockpitDesigner() {
    const layoutId =this.cockpitService.cockpitDevice()?.layoutId
     this.router.navigate(['./cockpit-designer'], {
      queryParams: { id:layoutId, name:this.selectedDevice()?.name },
      queryParamsHandling: 'merge',
    }) 
  }

  joinBroadcast() {
    const device = this.selectedDevice();
    if (!device || !device.id) return;
    this.deviceSocketService.connectToBot(device.id, this.ngZone);
  }
}
